import React, { useEffect, useState } from 'react';
import {
    Grid,
    Box,
    Typography,
    Divider,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
} from '@mui/material';
import { CloseIcon, PlusIcon, Trash } from '../../../assets';
import { CustomReactSelect, CustomButton, CustomSwitch, CustomDivider } from '../../shared';
import SFTPConnection from './sftpConnection';
import { useDispatch, useSelector } from 'react-redux';
import { getPartnerConnections } from '../../../redux/thunks/partnerThunk';
import { selectCampaignPartnerOptions } from '../../../redux/reducers/campaignReducer';
import { getSelectedCampaignPartners } from '../../../redux/thunks/campaignThunks';
import { actions } from '../../../redux/reducers/dataSourcesReducer';
import { toast } from 'react-toastify';
import { styled } from '@mui/styles';
import { updateDataSourceById, uploadDataSourceFile } from '../../../redux/thunks/dataSourcesThunk';
import { RiFileUploadLine } from "react-icons/ri";

const TYPE_OPTIONS = [
    { "label": 'string', "value": "string" },
    { "label": 'array', "value": "array" },
    { "label": 'number', "value": "number" },
    { "label": 'date', "value": "date" },
];

function EditDataSource(props) {
    const { handleClose } = props;
    const sftpConnectionRef = React.useRef();
    const dispatch = useDispatch();
    const { company } = useSelector(state => state.company)
    const { dataSource } = useSelector(state => state.dataSources);
    const [fields, setFields] = useState([]);
    const [isValid, setIsValid] = useState(false);
    const [errMessages, setErrMessages] = useState([]);
    const [updatedDataSource, setUpdatedDataSource] = useState({})
    const campaignPartners = useSelector(selectCampaignPartnerOptions());
    const [selectedFile, setSelectedFile] = React.useState(null);

    const VisuallyHiddenInput = styled('input')({
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(50%)',
        height: 1,
        overflow: 'hidden',
        position: 'absolute',
        bottom: 0,
        left: 0,
        whiteSpace: 'nowrap',
        width: 1,
      });
     useEffect(() => {
        if(Object?.keys(dataSource)?.length>0){
            dispatch(getPartnerConnections({companyId: company.id}))
            dispatch(getSelectedCampaignPartners({ companyId: company.id }));
            setUpdatedDataSource({
                id: dataSource.id,
                name:dataSource.name})
            if(dataSource.fields.length>0){
                setFields(dataSource.fields)
            }
            
        }

    }, [dataSource] )

    const handleAddFields = () => {
        setFields(prevFields => [
            ...prevFields,
            {
                id: Date.now(),
                name: '',
                rename_to: '',
                data_type: 'string',
                is_trigger: false,
                is_fmt: false,
            },
        ]);
    };

    const handleColumnNameChange = (index, value) => {
        setFields(prevFields => {
            const newFields = [...prevFields];
            const updatedField = { ...newFields[index], name: value };
            newFields[index] = updatedField; 

            setErrMessages(prevMessages => {
                const updatedMessages = [...prevMessages];
                updatedMessages[index] = '';
                return updatedMessages;
            });
            return newFields;
        });
        
    };
    

    const handleRenameToChange = (index, value) => {
        setFields(prevFields => {
            const newFields = [...prevFields];
            const updatedField = {...newFields[index], rename_to: value};
            newFields[index] = updatedField;
            return newFields;
        });
    };

    const handleTypeChange = (index, selectedOption) => {
        setFields(prevFields => {
            const newFields = [...prevFields];
            const updatedField = {...newFields[index], data_type: selectedOption.value};
            newFields[index] = updatedField;
            return newFields;
        });
    };

    const handleIsTriggerChange = (index) => {
        setFields(prevFields => {
            const updatedFields = prevFields?.map((field, idx) => {
                if (idx === index) {
                    return { ...field, is_trigger: !field.is_trigger };
                }
                return field;
            });
            return updatedFields;
        });
    };
    const handleIsFMTChange = (index) => {
        setFields(prevFields => {
            const updatedFields = prevFields?.map((field, idx) => {
                if (idx === index) {
                    return { ...field, is_fmt: !field.is_fmt };
                }
                return field;
            });
            return updatedFields;
        });
    };

   

    const handleDataSourceNameChange = (value) => {
        const correctValue = value.replace(/<script.*?>|<\/script>|on\w+=".*?"/gi, '');
        setUpdatedDataSource({...updatedDataSource,name:correctValue});
    }
    
    const handleRemoveField = (index) => {
        setFields(prevFields => prevFields.filter((_, i) => i !== index));
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        setSelectedFile(file);
      };

    const handleSubmit = () => {
        let isValid = true;
        let errorMessages = Array(fields.length).fill('');
    for (let i = 0; i < fields.length; i++) {
        const field = fields[i];
        if (field.name?.toLowerCase() === 'partner preference' && field.data_type !== "array") {
            errorMessages[i] = 'Partner Preference must be of Type array';
            isValid = false;
        } else if (field.name?.toLowerCase() === 'segmentation' && field.data_type !== "array") {
            errorMessages[i] = 'Segmentation must be of Type array';
            isValid = false;
        } else if (field.name?.toLowerCase() === 'channel preference' && field.data_type !== "array") {
            errorMessages[i] = 'Channel Preference must be of Type array';
            isValid = false;
        }
    }

    setErrMessages(errorMessages);
    setIsValid(isValid);
       if (sftpConnectionRef.current && isValid && dataSource?.partner?.name) {
        sftpConnectionRef.current.submitForm(handleClose);
      } 
      else{
        saveDataSources()
      }
    };

    const saveDataSources = () => {
        dispatch(updateDataSourceById({companyId:company.id, dataSourceId: dataSource?.id, data: {
            fields: fields,
            name:updatedDataSource?.name,
            partner_id: dataSource?.partner_id,
        } }))
    }

    useEffect(() => {
        if (selectedFile) {
            const formData = new FormData();
            formData.append('upload', selectedFile);
            dispatch(
                uploadDataSourceFile({
                    companyId: company.id,
                    dataSourceId: dataSource.id,
                    file: formData,
                })
            ).then((result)=> {
                setSelectedFile(null);
            }).catch(error => toast.error("Error in Uploading file.", error));
        }
    }, [selectedFile]);

    return (
        <Grid
            container
            className='modal_main'>
            <Grid item xs={12}>
                <Box className="padding-24px">
                    {/* Edit data source */}
                    <Box className="flex-row-space-between pb-24px" >
                        <Typography className='text-lg-medium gray-900'>
                            Edit data source
                        </Typography>
                        <Box className="cursor-pointer" onClick={handleClose}>
                            <CloseIcon color="#98A2B3" width='12' height='12' />
                        </Box>
                    </Box>

                    {/* Data Source Name */}
                    <Box className="flex-column gap-6 pb-24px w-100">
                        <Typography className='metrics-dropdown-title'>
                            Data Source Name
                        </Typography>
                        <input
                            type="text"
                            placeholder='Data Source Name'
                            value={updatedDataSource?.name}
                            className='query_name-input-field'
                            onChange={(e) => handleDataSourceNameChange(e.target.value)}
                        />
                    </Box>

                    {/* Partner */}
                    <Box className="flex-row gap-24" >
                        <CustomReactSelect
                            label='Partner'
                            options={campaignPartners}
                            selectedOption={
                                campaignPartners.find(partner => partner.name === (dataSource?.partner?.name || ''))
                              }
                            placeholder='Select Partner'
                            disable={true}
                        />
                    </Box>
                    {/* Upload file for Manual partner */}
                    {dataSource?.partner?.name === "Manual" ?
                        <Box className="flex-column gap-6 mt-32px w-100">
                            <Typography className='metrics-dropdown-title'>
                                Upload Data
                            </Typography>
                            <Button component="label" variant="contained" className='upload-button'  startIcon={<RiFileUploadLine />} >
                                Upload Data
                                <VisuallyHiddenInput type="file" onChange={handleFileChange} accept={".csv"}/>
                            </Button>
                        </Box> : null
                    }
                    


                {/* sftp connection */}
                {dataSource?.partner?.name === "Manual" ? null:
                    <Box className="mt-3 mb-3">
                        <SFTPConnection partnerId={dataSource?.partner_id} ref={sftpConnectionRef} connectionId={dataSource?.partner_connection_id || null} dataSourceData= {{fields: fields, updatedData: updatedDataSource}}/>
                    </Box>
                }

                    {/* Fields */}
                    <Box>
                        <Box className="padding-tb-24-rl-0">
                            <Typography className='text-500fw-18fs-28lh'>
                                Fields
                            </Typography>
                        </Box>
                        <Box className='p-16-br-16-odd-row gap-24' >
                            <TableContainer component={Paper} className='no-box-shadow no-border'>
                                <Table className='table-border-collapse no-border' cellSpacing={10}>
                                    <TableHead
                                        sx={{
                                            '& .MuiTableCell-root': {
                                                padding: '0px',
                                            },
                                        }}
                                    >
                                        <TableRow className="bg-gray-50">
                                            <TableCell width={"25%"} className="table-headers-title-with-no-padding no-border" align='left'>Column Name</TableCell>
                                            <TableCell width={"25%"} className="table-headers-title-with-no-padding no-border" align='left'>Rename Column To</TableCell>
                                            <TableCell width={"25%"} className="table-headers-title-with-no-padding no-border" align='left'>Type</TableCell>
                                            <TableCell width={"25%"} className="table-headers-title-with-no-padding no-border" align='left'>Is Trigger</TableCell>
                                            <TableCell width={"25%"} className="table-headers-title-with-no-padding no-border" align='left'>Is FMT</TableCell>

                                        </TableRow>
                                    </TableHead>
                                    <TableBody className='bg-gray-50'>
                                        {fields?.map((field, index) => (
                                            <TableRow key={field.id} >
                                                <TableCell width={"25%"} className='no-border no-table-border-cell' align='left'>
                                                    <Box >
                                                        <input
                                                            type="text"
                                                            placeholder='Column Name'
                                                            value={field.name}
                                                            onChange={(e) => handleColumnNameChange(index, e.target.value)}
                                                            className='dataSource_column_name_input_field' />
                                                        {!isValid && <span className="text-xs-regular error-500">
                                                            {errMessages[index]}
                                                        </span>}
                                                    </Box>
                                                </TableCell>
                                                <TableCell width={"25%"} className='no-border no-table-border-cell' align='left'>
                                                    <Box>
                                                        <input

                                                            type="text"
                                                            placeholder='Rename To'
                                                            value={field.rename_to}
                                                            onChange={(e) => handleRenameToChange(index, e.target.value)}
                                                            className='dataSource_column_name_input_field'/>
                                                    </Box>
                                                </TableCell>
                                                <TableCell width={"25%"} className='no-border no-table-border-cell' align='left'>
                                                    <Box >
                                                        <CustomReactSelect
                                                            options={TYPE_OPTIONS}
                                                            handleFilter={handleTypeChange}
                                                            placeholder={<div>Select Type</div>}
                                                            selectedOption={TYPE_OPTIONS.find(type=>{return type.value ===field.data_type})}
                                                            index={index}
                                                            useMenuPortalTarget={true}
                                                        />
                                                    </Box>
                                                </TableCell>
                                                <TableCell width={"25%"} className='no-border no-table-border-cell ' align='left'>
                                                    <Box className="flex-row-center gap-24">
                                                        <Box >
                                                            <CustomSwitch
                                                                checked={field.is_trigger}
                                                                onChange={handleIsTriggerChange}
                                                                id={index}
                                                            />
                                                        </Box>
                                                    </Box>
                                                </TableCell>
                                                <TableCell width={"25%"} className='no-border no-table-border-cell ' align='left'>
                                                    <Box className="flex-row-center gap-24">
                                                        <Box >
                                                            <CustomSwitch
                                                                checked={typeof field.is_fmt === "boolean" ? field.is_fmt : Boolean(field.is_fmt)}
                                                                onChange={handleIsFMTChange}
                                                                id={index}
                                                            />
                                                        </Box>
                                                        <Box className="cursor-pointer"
                                                            
                                                            onClick={() => handleRemoveField(index)}
                                                        >
                                                            <Trash color='#667085' />
                                                        </Box>
                                                    </Box>
                                                </TableCell>
                                                
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </Box>

                    {/* Add Field */}
                    <Box className="box-sizing-border-box padding-tb-24-rl-0">
                        <CustomDivider spacing="8px" hideLefttDivider={true}>
                            <CustomButton
                                title="Add Field"
                                titleColor="#344054"
                                buttonColor="#FFFFFF"
                                icon={<PlusIcon />}
                                handleClick={handleAddFields}
                            />
                        </CustomDivider>
                    </Box>
                </Box>
            </Grid>

            <Grid
                item
                xs={12}
                className='flex-1-mt-auto'
                >
                <Divider className='border-1-gray'/>
                <Box className='flex-row-end-center gap-12 padding-tb-16-rl-24'>
                    <CustomButton
                        title="Cancel"
                        handleClick={handleClose}
                    />
                    <CustomButton
                        title="Save"
                        titleColor="#FFFFFF"
                        buttonColor="#AD509E"
                        handleClick={handleSubmit}
                        type="submit"
                    />
                </Box>
            </Grid>
        </Grid>

    )
}

export default EditDataSource;